const WEIGHT_UNIT_FACTORS = {
  g: 1,
  gr: 1,
  kg: 1000
};

const VOLUME_UNIT_FACTORS = {
  ml: 1,
  lt: 1000,
  l: 1000
};

function normalizeUnit(unit) {
  return String(unit || '').trim().toLocaleLowerCase('tr-TR');
}

function roundPrice(value) {
  const numeric = Number(value || 0);
  if (!(numeric > 0)) return 0;
  return Number(numeric.toFixed(2));
}

export function formatShoppingSeedPrice(value) {
  const numeric = Number(value || 0);
  if (!(numeric > 0)) return 'Fiyat bekleniyor';
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(numeric);
}

export function estimateSeedLinePrice({
  amount,
  unit,
  defaultPrice,
  defaultPriceUnit
}) {
  const qty = Number(amount || 0);
  const seed = Number(defaultPrice || 0);
  if (!(qty > 0) || !(seed > 0)) return 0;

  const normalizedUnit = normalizeUnit(unit);
  const normalizedSeedUnit = normalizeUnit(defaultPriceUnit);

  if (normalizedUnit === normalizedSeedUnit) {
    return roundPrice(qty * seed);
  }

  const weightFactor = WEIGHT_UNIT_FACTORS[normalizedUnit];
  const seedWeightFactor = WEIGHT_UNIT_FACTORS[normalizedSeedUnit];
  if (weightFactor && seedWeightFactor) {
    const qtyInGrams = qty * weightFactor;
    const seedUnitInGrams = seedWeightFactor;
    return roundPrice((qtyInGrams / seedUnitInGrams) * seed);
  }

  const volumeFactor = VOLUME_UNIT_FACTORS[normalizedUnit];
  const seedVolumeFactor = VOLUME_UNIT_FACTORS[normalizedSeedUnit];
  if (volumeFactor && seedVolumeFactor) {
    const qtyInMilliliters = qty * volumeFactor;
    const seedUnitInMilliliters = seedVolumeFactor;
    return roundPrice((qtyInMilliliters / seedUnitInMilliliters) * seed);
  }

  if (normalizedSeedUnit === 'adet' || normalizedSeedUnit === 'paket' || normalizedSeedUnit === 'kutu' || normalizedSeedUnit === 'koli') {
    return roundPrice(qty * seed);
  }

  return roundPrice(seed);
}

export function hydrateShoppingSeedDefaults(item = {}) {
  const next = { ...item };
  const defaultPrice = Number(next.defaultPrice || 0);
  const defaultPriceUnit = String(next.defaultPriceUnit || '').trim();
  const seededLinePrice = estimateSeedLinePrice({
    amount: next.amount,
    unit: next.unit,
    defaultPrice,
    defaultPriceUnit
  });

  next.defaultPrice = defaultPrice;
  next.defaultPriceUnit = defaultPriceUnit;
  next.defaultPriceSource = next.defaultPriceSource || 'NONE';
  next.requiresBrand = Boolean(next.requiresBrand);
  next.priceAutoFilled = defaultPrice > 0;

  if (defaultPrice > 0) {
    next.price = seededLinePrice;
  } else if (next.price === undefined || next.price === null) {
    next.price = 0;
  }

  return next;
}

export function applyShoppingSeedUpdate(item = {}, updates = {}) {
  const merged = {
    ...item,
    ...updates
  };

  if (merged.priceAutoFilled) {
    merged.price = estimateSeedLinePrice({
      amount: merged.amount,
      unit: merged.unit,
      defaultPrice: merged.defaultPrice,
      defaultPriceUnit: merged.defaultPriceUnit
    });
  }

  return merged;
}
